import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import MgtvApi from "@mgtv/jssdk";

window.MgtvApi = MgtvApi;
Vue.prototype.$EventBus = new Vue();
Vue.config.productionTip = false;
Vue.config.ignoredElements.push("wx-open-launch-app");
/** 测试环境 */
const isDev = window.location.href.indexOf("_cst=vconsole") !== -1;
if (isDev) {
  const VConsole = require("vconsole");
  new VConsole();
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
